import {i18n} from 'src/shared/config'

import {
  controlPanel as kazControlPanel,
  linksList as kazLinksList,
  linksListMobile as kazLinksListMobile,
} from './kaz'
import {
  controlPanel as rusControlPanel,
  linksList as rusLinksList,
  linksListMobile as rusLinksListMobile,
} from './rus'

export const countryData = [
  {
    href: 'https://delivery.yandex.com/am-ru/',
    label: i18n('order.header.country.armenia', 'Армения'),
    countryCode: 'arm',
  },
  {
    href: 'https://delivery.yandex.by/',
    label: i18n('order.header.country.belarus', 'Беларусь'),
    countryCode: 'blr',
    tld: 'by',
  },
  {
    href: 'https://delivery.yandex.com/ge-en/',
    label: i18n('order.header.country.georgia', 'Грузия'),
    countryCode: 'geo',
  },
  {
    href: 'https://delivery.yandex.kg/',
    label: i18n('order.header.country.kyrgyzstan', 'Кыргызстан'),
    countryCode: 'kgz',
    tld: 'kg',
  },
  {
    href: 'https://delivery.yandex.kz/',
    label: i18n('order.header.country.kazakhstan', 'Казахстан'),
    countryCode: 'kaz',
    tld: 'kz',
  },
  {
    href: '/',
    label: i18n('order.header.country.russia', 'Россия'),
    countryCode: 'rus',
    tld: 'ru',
  },
  {
    href: 'https://delivery.yandex.uz/',
    label: i18n('order.header.country.uzbekistan', 'Узбекистан'),
    countryCode: 'uzb',
    tld: 'uz',
  },
]

export const controlPanel = {
  kz: kazControlPanel,
  ru: rusControlPanel,
}

export const linksList = {
  kz: kazLinksList,
  ru: rusLinksList,
}

export const linksListMobile = {
  kz: kazLinksListMobile,
  ru: rusLinksListMobile,
}
